import React from 'react'

function register_master() {
  return (
    <div>
      
    </div>
  )
}

export default register_master
